import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'sonner';
import { AuthProvider, useAuth } from './context/AuthContext';
import { CategoryProvider } from './context/CategoryContext';
import { StripeProvider } from './context/StripeContext';
import { AdminLayout } from './components/layout/AdminLayout';
import { Login } from './pages/Login';
import { ResetPassword } from './pages/ResetPassword';
import { Dashboard } from './pages/Dashboard';
import { Products } from './pages/Products';
import { Orders } from './pages/Orders';
import { Customers } from './pages/Customers';
import { Users } from './pages/Users';
import { Content } from './pages/Content';
import { Marketing } from './pages/Marketing';
import { Financial } from './pages/Financial';
import { Inventory } from './pages/Inventory';
import { Analytics } from './pages/Analytics';
import { Settings } from './pages/Settings';
import Affiliates from './pages/Affiliates';
import { PublicProcurementBatch } from './pages/PublicProcurementBatch';
import RushdAnalytics from './pages/RushdAnalytics';
import { Bundles } from './pages/Bundles';

// Protected Route Component
function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { currentUser, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="w-16 h-16 bg-gradient-to-br from-jamaica-green to-jamaica-green/80 rounded-full flex items-center justify-center">
          <div className="w-8 h-8 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
        </div>
      </div>
    );
  }

  return currentUser ? (
    <CategoryProvider>
      {children}
    </CategoryProvider>
  ) : <Navigate to="/login" replace />;
}

function App() {
  return (
    <AuthProvider>
      <StripeProvider>
        <Router>
          <div className="min-h-screen bg-gray-50">
            <Toaster 
              position="top-right"
              richColors
              closeButton
              duration={4000}
              expand={true}
              visibleToasts={5}
              toastOptions={{
                style: {
                  marginBottom: '8px',
                },
                className: 'admin-toast',
              }}
            />
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/procurement-batch/:batchId/:token" element={<PublicProcurementBatch />} />
              <Route
                path="/*"
                element={
                  <ProtectedRoute>
                    <AdminLayout />
                  </ProtectedRoute>
                }
              >
                <Route index element={<Dashboard />} />
                <Route path="products" element={<Products />} />
                <Route path="orders" element={<Orders />} />
                <Route path="bundles" element={<Bundles />} />
                <Route path="customers" element={<Customers />} />
                <Route path="users" element={<Users />} />
                <Route path="content" element={<Content />} />
                <Route path="marketing" element={<Marketing />} />
                <Route path="financial" element={<Financial />} />
                <Route path="inventory" element={<Inventory />} />
                <Route path="analytics" element={<Analytics />} />
                <Route path="affiliates" element={<Affiliates />} />
                <Route path="settings" element={<Settings />} />
                <Route path="rushd/analytics" element={<RushdAnalytics />} />
              </Route>
            </Routes>
          </div>
        </Router>
      </StripeProvider>
    </AuthProvider>
  );
}

export default App;
